import React from "react";
import "../css/terms.scss";
import { Link } from "react-router-dom";

function Terms() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <main
      id="MainContent"
      className="main-content content-for-layout focus-none"
      role="main"
      tabIndex={-1}
    >
      <div className="shopify-policy__container">
        <div className="shopify-policy__title">
          <h1>Terms of service</h1>
        </div>
        <div className="shopify-policy__body">
          <div className="rte">
            <h2>
              <strong>Introduction</strong>
            </h2>
            <p>
              Thank you for visiting the Pedarcircle website at
              www.pedarcircle.club (the <strong>Website</strong>). Please read
              and check that you agree with the following terms of use (the{" "}
              <strong>Terms</strong>) before you use or buy anything from the
              Website. The Terms are a contract that you enter into with us. We
              recommend you print a copy of these Terms for future reference.
            </p>
            <p>
              The Website is operated by Andcrafted Limited which trades as{" "}
              <strong>Pedarcircle</strong>. The terms <strong>we</strong>,{" "}
              <strong>us</strong>, <strong>our</strong> and{" "}
              <strong>Pedarcircle</strong> all refer to Andcrafted Limited.
            </p>
            <p>
              We are an English company with registered number 11827691 and
              business office address at Unit C1 Leyton Industrial Village,
              Argall Avenue, London, E10 7QP, United Kingdom. Our VAT number is
              GB 297522174.
            </p>
            <p>
              The Terms are only applicable to our customers who are consumers.
              If you are a trade customer please contact us separately to obtain
              the relevant Terms and Conditions of Sale.
            </p>
            <h2>
              <strong>Communications</strong>
            </h2>
            <p>
              Questions about the Terms should be sent to us by email at
              draft@pedarcircle.club or you can contact us using our{" "}
              <Link onClick={toTop} to="/contact" title="Contact Form">
                contact form
              </Link>{" "}
              and request a call back.
            </p>
            <p>
              If you would like the Terms in another format (for example: audio
              or large print) please contact us at draft@pedarcircle.club.
            </p>
            <p>
              We may contact you by phone, text, email or post using the contact
              details you have provided to us.
            </p>
            <h2>
              <strong>Overview</strong>
            </h2>
            <p>
              These Terms apply to your use of the Website including all
              information, tools, services and products available on or via the
              Website. By using the Website or placing an order with us, you are
              agreeing to accept and be bound by the Terms including any
              additional terms and policies such as our{" "}
              <Link onClick={toTop} to="/privacy">
                <strong>Privacy Policy</strong>{" "}
              </Link>
              (which also includes our <strong>Cookie Policy</strong>) and our{" "}
              <Link onClick={toTop} to="/">
                <strong>Social Media Policy</strong>
              </Link>{" "}
              which we refer to in the Terms and make available by hyperlink.
            </p>
            <p>
              We may transfer our rights and obligations under the Terms to
              another organisation. We will always tell you in writing if this
              happens and we will ensure that the transfer will not affect your
              rights under the Terms.
            </p>
            <p>
              Any new features or tools which are added to the Website will also
              be subject to the Terms. We reserve the right to update, change or
              replace any part of the Terms by posting updates to the Website.
              You can review the most current version of the Terms at any time
              on this page. It is your responsibility to check this page
              periodically for changes. Your continued use of or access to the
              Website following the posting of any changes constitutes
              acceptance of those changes.
            </p>
            <p>
              The Terms apply to all users of the Website, including, without
              limitation, browsers, vendors, customers, merchants, and any
              contributors of content. The Terms are split into three parts the
              first part concerns the purchase of products from us using the
              Website. The second part concerns your use of the Website. The
              third part concerns general terms which apply to both your
              purchase of products and your use of the Website.
            </p>
            <h2>
              <strong>PART ONE – purchase of products from Pedarcircle</strong>
            </h2>
            <p>This part sets out:</p>
            <ul>
              <li>your legal rights and responsibilities;</li>
              <li>our legal rights and responsibilities; and</li>
              <li>certain key information required by law.</li>
            </ul>
            <p>
              If you buy products on the Website, you agree to be legally bound
              by the Terms.
            </p>
            <h3>
              <strong>Your privacy and personal information</strong>
            </h3>
            <p>
              Our <strong>Privacy Policy</strong>, including our{" "}
              <strong>cookie policy</strong> is available{" "}
              <Link
                onClick={toTop}
                to="/privacy"
                title="Privacy & Cookies Policy"
              >
                here
              </Link>
              . Any personal information that you provide to us will be dealt
              with in line with our Privacy Policy, which explains what personal
              information we collect from you, how and why we collect, store,
              use and share such information, your rights in relation to your
              personal information and how to contact us and supervisory
              authorities if you have a query or complaint about the use of your
              personal information.
            </p>
            <h3>
              <strong>Ordering products from us</strong>
            </h3>
            <p>
              This is how a legally binding contract for the purchase of
              products (the <strong>Contract</strong>) is made between you and
              us:
            </p>
            <ol>
              <li>
                You place an order on the Website by adding products to your
                shopping cart and proceeding to the checkout. Please review and
                check your order carefully before submitting it for payment. You
                will be able to correct any errors before submitting your order
                to us.
              </li>
              <li>
                When you place your order at the end of the online checkout
                process (i.e. when you click to submit payment), we will
                acknowledge it by email and, in some circumstances, text
                message. This acknowledgement <u>does not mean</u> that your
                order has been accepted by us.
              </li>
              <li>
                We may contact you via the information you provided to us to say
                that we do not accept your order. This is typically for the
                following reasons:
                <ul>
                  <li>the products are unavailable;</li>
                  <li>we cannot authorise your payment;</li>
                  <li>you are not allowed to buy the products from us;</li>
                  <li>we are not allowed to sell the products to you;</li>
                  <li>you have ordered too many products; or</li>
                  <li>
                    there has been a mistake on the pricing or description of
                    the products.
                  </li>
                </ul>
              </li>
              <li>
                We will only accept your order when we email you to confirm
                shipping (the <strong>Dispatch Email</strong>). At this point
                the Contract is legally binding and we will dispatch the
                products that you have ordered to you.
              </li>
            </ol>
            <p>
              We reserve the right, but are not obligated, to limit the sales of
              our products to any person, geographic region or jurisdiction or
              to persons that, in our sole judgment, appear to be placed by
              dealers, resellers or distributors. We may exercise this right on
              a case-by-case basis. We reserve the right to limit the quantities
              of any products or services that we offer.
            </p>
            <h3>
              <strong>Right to cancel</strong>
            </h3>
            <p>
              As explained above, in most circumstances, you have the right to
              cancel the Contract within 14 days without giving any reason (the{" "}
              <strong>Cancellation Period</strong>).
            </p>
            <p>
              The Cancellation Period will expire after 14 days from the day on
              which you acquire physical possession of the products. This
              applies regardless of whether you acquire the products directly or
              indirectly via someone else (apart from our carrier). &nbsp;
            </p>
            <p>
              To use your right to cancel, you must inform us of your decision
              to cancel the Contract by a clear statement using the contact
              details at the beginning of these Terms. An example of this
              cancellation request is available{" "}
              <Link onClick={toTop} to="/">
                here
              </Link>
              . You must tell us that you would like to use your right to cancel
              before the Cancellation Period has expired.
            </p>
            <p>
              The above describes your legal rights. In practical terms, once
              you have received the goods you may use our 60 day returns process
              to return unwanted goods to us and obtain a refund. This process
              is described in our{" "}
              <Link onClick={toTop} title="Refund Policy." to="/returns">
                Refund Policy.
              </Link>
            </p>
            <h3>
              <strong>Effects of cancellation</strong>
            </h3>
            <p>
              If you cancel the Contract within 14 days of delivery, we will
              refund you all payments received from you, including the{" "}
              <strong>cost of the items</strong> and the{" "}
              <strong>standard delivery charge</strong>, provided you return the{" "}
              <strong>entire order</strong>. If only part of your order is
              returned, we are not required to refund the delivery cost.
            </p>
            <p>
              If you selected a more expensive delivery option, we will only
              refund the standard delivery charge and not the additional amount.
            </p>
            <p>
              If you return your order between <strong>15 and 60 days</strong>{" "}
              after delivery, we will refund the item cost <strong>only</strong>
              , and a <strong>£5 restocking fee per order</strong> will be
              deducted from your refund.
            </p>
            <p>
              We may also make a deduction for any reduction in the value of the
              products if the loss in value was caused by unnecessary handling.
            </p>
            <p>
              Refunds will be issued using your original payment method and
              processed as soon as possible, and no later than 14 days after we
              receive the returned items.
            </p>
            <p>
              You may use our{" "}
              <Link onClick={toTop} to="/returns">
                online returns portal
              </Link>{" "}
              to generate a return shipping label. Please ensure items are
              packaged appropriately to arrive in original condition.
            </p>
            <h3>
              <strong>Accuracy of billing and account information</strong>
            </h3>
            <p>
              You can register to create an account with us by inputting your
              name, email and password via the{" "}
              <Link onClick={toTop} to="/">
                Account Registration Page
              </Link>
              .
            </p>
            <p>
              You agree to provide current, complete and accurate purchase and
              account information for all purchases made from the Website. You
              agree to promptly update your account and other information,
              including your email address and credit card numbers and
              expiration dates, so that we can complete your transactions and
              contact you as needed.
            </p>
            <p>
              For more detail, please review our{" "}
              <Link onClick={toTop} to="/returns">
                <strong>Returns &amp; Delivery</strong>
              </Link>{" "}
              page and{" "}
              <Link onClick={toTop} to="/returns" title="Refund Policy">
                <strong>Refunds Policy</strong>
              </Link>
              .
            </p>
            <h3>
              <strong>Delivery</strong>
            </h3>
            <p>
              For local deliveries in the UK, we use Royal Mail &amp; DPD to
              deliver our products. For information on delivery options and
              costs, please visit our{" "}
              <Link
                onClick={toTop}
                to="/shipping"
                title="Delivery & Returns Page"
              >
                <strong>Delivery &amp; Returns</strong>
              </Link>{" "}
              page. During the online checkout process, you will be given
              available delivery options to choose from. For information about
              international orders, please see the international orders section
              below.
            </p>
            <p>
              The estimated date for delivery of the products is set out in the
              Confirmation Email. If something happens which is outside of our
              control and affects the estimated date of delivery, we will
              provide you with a revised estimated date for delivery. We will
              not be liable for failure to deliver caused by an event outside
              our control or because you failed to provide adequate delivery
              instructions.&nbsp; If we can’t supply certain products, we will
              contact you to let you know as soon as possible and, if a payment
              has already been made,{" "}
              <span>
                refund you for those items or offer a reasonable alternative.
              </span>
            </p>
            <p>
              Delivery will take place at the address specified by you when you
              placed your order with us.
            </p>
            <p>
              Unless you and we agree otherwise, if we cannot deliver your
              products within 30 days of the date of your Confirmation Email, we
              will let you know, cancel your order and give you a refund.
            </p>
            <p>
              If nobody is available to take delivery, please contact us using
              the contact details at the beginning of these Terms.
            </p>
            <p>
              You are responsible for the products once they have been delivered
              to the address specified by you when you placed your order with
              us. In other words, the risk in the products passes to you when
              you take, or a third party notified by you takes, possession of
              the products.
            </p>
            <h3>
              <strong>Payment</strong>
            </h3>
            <p>
              For customers in the UK, all prices are in pounds sterling
              (£)(GBP) and include VAT at the applicable rate, but exclude
              delivery charges.
            </p>
            <p>
              For customers outside the UK,&nbsp;please see the international
              orders section below.
            </p>
            <p>
              For information on delivery options and costs, visit our{" "}
              <Link
                onClick={toTop}
                to="/shipping"
                title="Delivery & Returns Page"
              >
                <strong>Delivery &amp; Returns</strong>
              </Link>{" "}
              page.
            </p>
            <p>
              You agree to provide current, complete and accurate information
              regarding your name, billing address, delivery address and payment
              card details for all purchases made using the Website. If any of
              this information changes, you agree to promptly update your
              account and other information, including your email address and
              credit card numbers and expiration dates, so that we can complete
              your transactions and contact you as needed.
            </p>
            <p>
              We accept the following credit and debit cards: American Express,
              Apple Pay, Diners Club, Discover, Maestro, Mastercard, PayPal,
              Shop Pay, Visa. We also accept payment via Klarna – see later in
              the Terms for details. All payments by credit card or debit card
              need to be authorised by the relevant card issuer. The card issuer
              may also need to use extra security steps to verify your identity.
            </p>
            <p>
              Your credit card or debit card will be charged when the products
              are purchased. All payments by credit or debit card must be
              authorised by the relevant card issuer.
            </p>
            <p>
              If we can’t supply certain products, we will contact you to let
              you know as soon as possible and, if a payment has already been
              made, refund you for the products we cannot supply.
            </p>
            <p>
              Please contact us at{" "}
              <Link
                onClick={toTop}
                title="draft@pedarcircle.club"
                to="mailto:draft@pedarcircle.club"
              >
                draft@pedarcircle.club
              </Link>{" "}
              if you have any questions about the products that we have provided
              to you.
            </p>
            <p>
              If your payment is not received by us and you have already
              received products, you must:
            </p>
            <ol>
              <li>
                pay for such products as soon as possible and in any case within
                14 days; or
              </li>
              <li>
                return them to us as soon as possible and in any case within 30
                days. If so, you must keep the products in your possession, take
                reasonable care of them and not use them before you return them
                to us.
              </li>
            </ol>
            <p>
              If you do not pay for the products and fail to return them, we may
              collect the products from you at your expense.
            </p>
            <h3>
              <strong>Using Klarna</strong>
            </h3>
            <p>
              In cooperation with Klarna Bank AB (publ), Sveavägen 46, 111 34
              Stockholm, Sweden, we offer you the option to Pay Later with
              Klarna:{" "}
              <Link onClick={toTop} to="/">
                here
              </Link>
              .
            </p>
            <p>
              <span>
                Klarna's Pay in 3 / Pay in 30 days are unregulated credit
                agreements. Borrowing more than you can afford or paying late
                may negatively impact your financial status and ability to
                obtain credit. 18+, UK residents only. Subject to status. Late
                fees may apply.
              </span>
            </p>
            <p>
              Further information and Klarna’s user terms is{" "}
              <Link onClick={toTop} to="/terms">
                here
              </Link>
              .
            </p>

            <h3>
              <strong>Nature of the products</strong>
            </h3>
            <p>
              The Consumer Rights Act 2015 gives you certain legal rights (also
              known as “<em>statutory rights</em>”). The products that we
              provide to you must be as described, fit for purpose and of
              satisfactory quality.
            </p>
            <p>
              We are under a legal duty to supply you with products that are in
              conformity with this contract.
            </p>
            <h3>
              <strong>Modification of the products</strong>
            </h3>
            <p>
              We do not warrant that the quality of any products, services,
              information, or other material purchased or obtained by you will
              meet your expectations.
            </p>
            <p>
              All descriptions of products including product pricing are subject
              to change at any time without notice. We reserve the right to
              discontinue any product at any time.
            </p>
            <p>
              The packaging of the products may be different from that shown on
              the Website.
            </p>
            <p>
              The images of the products on the Website are for illustrative
              purposes only. We have made every effort to display the colours
              and images of our products that appear on the Website as
              accurately as possible. We cannot guarantee that your computer
              monitor's display of any colour will be accurate. Consequently,
              your product may vary slightly from those images.
            </p>
            <p>
              All descriptions of products or product pricing are subject to
              change at any time without notice, at the sole discretion of us.
              We reserve the right to discontinue any product at any time. Any
              offer for any product or service made on this site is void where
              prohibited.
            </p>
            <p>
              All descriptions of products including product pricing are subject
              to change at any time without notice. We reserve the right to
              discontinue any product at any time.
            </p>
            <p>
              If we cannot supply certain products, we may need to substitute
              them with alternative products of equal or better standard and
              value. In this case:
            </p>
            <ul>
              <li>
                we will let you know if we intend to do this but this may not
                always be possible; and
              </li>
              <li>
                you can refuse to accept such substitutes, in which case we will
                offer you a refund or a replacement and let you know how long
                such an offer remains open for.
              </li>
            </ul>
            <h3>
              <strong>Faulty products</strong>
            </h3>
            <p>
              Products that we provide to you must be as described, fit for
              purpose and of satisfactory quality. During the expected lifespan
              of your product, your rights from the date of purchase include the
              following:
            </p>
            <ul>
              <li>
                Up to 60 days: if your products are faulty, you can get a
                refund.
              </li>
              <li>
                Up to six months: if your products cannot be repaired or
                replaced, then you are entitled to a full refund in most cases.
              </li>
              <li>
                Up to six years: if the products do not last a reasonable length
                of time, you may be entitled to some money back.
              </li>
            </ul>
            <p>
              Please note that if you are provided with a replacement product
              after receiving a faulty product, we will not be able to reimburse
              you for third party installation costs.
            </p>
            <p>You may also have other rights in law.</p>
            <p>
              For more detailed information on your rights and what you should
              expect from us, please:
            </p>
            <ul>
              <li>
                contact us using the contact details at the top of this page; or
              </li>
              <li>
                visit the Citizens Advice website www.citizensadvice.org.uk or
                call 0808 223 1133.
              </li>
            </ul>
            <p>
              If your products are faulty, please contact us using the contact
              details at the top of this page.
            </p>
            <h3>
              <strong>End of the contract for supply of products</strong>
            </h3>
            <p>
              If this contract is ended it will not affect our right to receive
              any money which you owe to us under this contract.
            </p>
            <p>
              The obligations and liabilities of the parties incurred prior to
              the end of the contract shall survive the termination of these
              Terms for all purposes.
            </p>
            <p>
              These Terms are effective unless and until terminated by either
              you or us. You may terminate these Terms at any time by notifying
              us or when you cease using the Website.
            </p>
            <p>
              If in our sole judgment you fail, or we suspect that you have
              failed, to comply with any term or provision of these Terms, we
              also may terminate these Terms at any time without notice and you
              will remain liable for all amounts due up to and including the
              date of termination; and/or accordingly may deny you access to the
              Website (or any part thereof).
            </p>
            <p>&nbsp;</p>
            <h3>International Orders</h3>
            <p>&nbsp;</p>
            <p>
              <span>
                For customers outside of the UK, you will be able to select to
                view prices in your home currency by using the flag selector on
                our Website.
              </span>
              <span>&nbsp; &nbsp; &nbsp; &nbsp;</span>
            </p>
            <p>
              <span>
                At the checkout stage, you will be able to view the available
                payment methods and shipping options (including costs of
                delivery in your local currency and approximate delivery timings
                for express and standard shipping).&nbsp;
              </span>
              All payments will be collected in your selected currency.
            </p>
            <p>
              <span>
                If you select an express shipping option, the parcel will be
                shipped to you via DHL. If you select a standard shipping
                option, your parcel will be shipped to you via a partner courier
                which will vary by location. You will be provided a tracking
                link when the parcel has been dispatched.
              </span>
            </p>
            <p>&nbsp;</p>
            <p>
              <span>You can also contact us at any time at&nbsp;</span>
              <Link onClick={toTop} to="mailto:draft@pedarcircle.club">
                draft@pedarcircle.club
              </Link>

              <span>, to discuss an international return.</span>
            </p>
            <p>&nbsp;</p>
            <h2>
              <strong>PART TWO - Your use of the Website</strong>
            </h2>
            <h3>
              <strong>Your account details</strong>
            </h3>
            <p>
              You must keep your account details safe. If you choose, or you are
              provided with, a user identification code, password or any other
              piece of information as part of our security procedures, you must
              treat such information as confidential. You must not disclose it
              to any third party.
            </p>
            <p>
              We have the right to disable any user identification code or
              password, whether chosen by you or allocated by us, at any time,
              if in our reasonable opinion you have failed to comply with any of
              the provisions of the Terms.
            </p>
            <p>
              If you know or suspect that anyone other than you knows your user
              identification code or password, you must promptly notify us at
              [draft@pedarcircle.club].
            </p>
            <p>
              <u>Our intellectual property rights</u>
            </p>
            <p>
              We own or licence all intellectual property rights in our Website,
              and in the material published on it including the original designs
              that we offer for sale. Those works are protected by copyright and
              other intellectual property laws such as registered and
              unregistered design right and equivalent rights are available in
              many countries around the world. All such rights are reserved. A
              full record of our registered designs in the UK and EU is
              available on request.
            </p>
            <p>
              You may print off one copy, and may download extracts, of any
              page(s) from our Website for your personal use and you may draw
              the attention of others within your organisation to content posted
              on our Website.
            </p>
            <p>
              You must not modify the paper or digital copies of any materials
              you have printed off or downloaded in any way, and you must not
              use any illustrations, photographs, video or audio sequences or
              any graphics separately from any accompanying text.
            </p>
            <p>
              Our status (and that of any identified contributors) as the
              authors of content on our Website must always be acknowledged
              (except where the content is user-generated).
            </p>
            <p>
              You must not use any part of the content on our Website for
              commercial purposes without obtaining a licence to do so from us
              or our licensors.
            </p>
            <p>
              If you print off, copy or download any part of our Website in
              breach of these terms of use, your right to use our Website will
              cease immediately and you must, at our option, return or destroy
              any copies of the materials you have made.
            </p>
            <h3>
              <strong>Do not rely on information on this site</strong>
            </h3>
            <p>
              The content on our Website is provided for general information
              only. It is not intended to amount to advice on which you should
              rely.
            </p>
            <p>
              Although we make reasonable efforts to update the information on
              our Website, we make no representations, warranties or guarantees,
              whether express or implied, that the content on our Website is
              accurate, complete or up to date. We are not responsible if
              information made available on the Website is not accurate,
              complete or current. The material on the Website is provided for
              general information only and should not be relied upon or used as
              the sole basis for making decisions without consulting primary,
              more accurate, more complete or more timely sources of
              information. Any reliance on the material on the Website is at
              your own risk.
            </p>
            <p>
              The Website may contain certain historical information. This
              information is not necessarily current and is provided for your
              reference only. We reserve the right to modify the contents of the
              Website at any time, but we have no obligation to update any
              information on the Website. You agree that it is your
              responsibility to monitor changes to the Website.
            </p>
            <p>
              The images of the products on the Website are for illustrative
              purposes only. We have made every effort to display as accurately
              as possible the colours and images of our products that appear on
              the Website. We cannot guarantee that your computer monitor's
              display of any colour will be accurate. Your product may vary
              slightly from those images.
            </p>
            <h3>
              <strong>Your use of the Website</strong>
            </h3>
            <p>
              You are responsible for configuring your information technology,
              computer programs and platform to access the Website. You should
              use your own virus protection software. We do not guarantee that
              the Website will be secure or free from bugs or viruses. We are
              not responsible for any viruses on the Website.
            </p>
            <p>
              You must not misuse our Website by knowingly introducing viruses,
              trojans, worms, logic bombs or other material that is malicious or
              technologically harmful. You must not attempt to gain unauthorised
              access to the Website, the server on which the Website is stored
              or any server, computer or database connected to the Website. You
              must not attack the Website via a denial-of-service attack or a
              distributed denial-of service attack. By breaching this provision,
              you would commit a criminal offence under the Computer Misuse Act
              1990. We will report any such breach to the relevant law
              enforcement authorities and we will co-operate with those
              authorities by disclosing your identity to them. In the event of
              such a breach, your right to use the Website will cease
              immediately.
            </p>
            <p>&nbsp;</p>
            <h3>
              <strong>
                We are not responsible for websites that we link to
              </strong>
            </h3>
            <p>
              Where our Website contains links to other sites and resources
              provided by third parties, these links are provided for your
              information only. Such links should not be interpreted as approval
              by us of those linked websites or information you may obtain from
              them.
            </p>
            <p>
              We have no control over the contents of those sites or resources.
            </p>
            <h3>
              <strong>Linking to the Website</strong>
            </h3>
            <ul>
              <li>
                You may link to the home page and product pages of the Website,
                provided you do so in a way that is fair and legal and does not
                damage our reputation or take advantage of it.
              </li>
              <li>
                We reserve the right to withdraw linking permission without
                notice.
              </li>
              <li>
                You must not establish a link in such a way as to suggest any
                form of association, approval or endorsement from us where none
                exists.
              </li>
              <li>
                You must not establish a link to the Website in any website that
                is not owned by you other than to your social media accounts.
              </li>
              <li>
                The Website must not be framed on any other website without our
                prior written permission.
              </li>
              <li>
                The website in which you are linking must comply in all respects
                with the content standards set out in our{" "}
                <Link onClick={toTop} to="/privacy">
                  Acceptable Use Policy
                </Link>
                .
              </li>
              <li>
                If you wish to link to or make any use of content on our Website
                other than that set out above, please contact [
                <Link onClick={toTop} to="mailto:draft@pedarcircle.club">
                  draft@pedarcircle.club
                </Link>
                ].
              </li>
            </ul>
            <h3>
              <strong>Comments, feedback and other submissions</strong>
            </h3>
            <p>
              We currently do not operate a comment function, chat room or
              provide users with the opportunity to otherwise upload content on
              the Website. If that changes in the future, the Terms will be
              updated. In any event, we take no responsibility and assume no
              liability for any comments posted by you or any third party.
            </p>
            <p>
              If you send certain specific submissions to us such as contest
              entries or, without a request from us, you send creative ideas,
              suggestions, proposals, plans, or other materials, whether online,
              by email, by postal mail, or otherwise (collectively,{" "}
              <strong>comments</strong>), you agree that:
            </p>
            <ul>
              <li>
                we may, at any time, without restriction, edit, copy, publish,
                distribute, translate and otherwise use the comments in any
                medium; and
              </li>
              <li>
                we are under no obligation to (1) keep the comments
                confidential, (2) pay compensation for the comments, or (3)
                respond to the comments.
              </li>
            </ul>
            <h3>
              <strong>Personal information</strong>
            </h3>
            <p>
              Your submission of personal information is governed by our{" "}
              <Link onClick={toTop} to="/privacy" title="Privacy Policy Page">
                Privacy Policy
              </Link>
              .
            </p>
            <p>
              Your privacy and personal information are important to us. Any
              personal information that you provide to us will be dealt with in
              accordance with our Privacy Policy, which explains what personal
              information we collect from you, how and why we collect, store,
              use and share such information, your rights in relation to your
              personal information and how to contact us and supervisory
              authorities if you have a query or complaint about the use of your
              personal information.
            </p>
            <p>
              Your credit card information is always encrypted during transfer
              over networks.
            </p>
            <h3>
              <strong>Errors, inaccuracies and omissions</strong>
            </h3>
            <p>
              Occasionally there may be information on the Website that contains
              typographical errors, inaccuracies or omissions that may relate to
              product descriptions, pricing, promotions, offers, product
              shipping charges, transit times and availability. We reserve the
              right to correct any errors, inaccuracies or omissions, and to
              change or update information or cancel orders if any information
              is inaccurate at any time without prior notice (including after
              you have submitted your order).
            </p>
            <p>
              We have no obligation to update, amend or clarify information on
              the Website, including without limitation, pricing information,
              except as required by law. No specified update or refresh date
              applied on the Website, should be taken to indicate that all
              information on the Website or on any related website has been
              modified or updated.
            </p>
            <h3>
              <strong>Prohibited uses</strong>
            </h3>
            <p>
              You are prohibited from using the Website or its content for any
              of the following uses:
            </p>
            <ul>
              <li>for any unlawful purpose;</li>
              <li>
                to solicit others to perform or participate in any unlawful
                acts;
              </li>
              <li>
                to infringe our intellectual property rights or the intellectual
                property rights of others;
              </li>
              <li>
                to harass, abuse, insult, harm, defame, slander, disparage,
                intimidate, or discriminate anyone;
              </li>
              <li>to submit false or misleading information;</li>
              <li>
                to upload or transmit viruses or any other type of malicious
                code that will or may be used in any way that will affect the
                functionality or operation of the Website, other websites, or
                the Internet;
              </li>
              <li>to collect or track the personal information of others;</li>
              <li>to spam, phish, pharm, pretext, spider, crawl, or scrape;</li>
              <li>for any obscene or immoral purpose; or</li>
              <li>
                to interfere with or circumvent the security features of the
                Website or any other websites, or the Internet.
              </li>
            </ul>
            <p>
              We reserve the right to terminate your use of the Website for
              violating any of the prohibited uses.
            </p>
            <h3>
              <strong>Disclaimer of warranties </strong>
            </h3>
            <p>
              We do not guarantee, represent or warrant that your use of the
              Website will be uninterrupted, timely, secure or error-free.
            </p>
            <p>
              We do not warrant that any search results that may be obtained
              from the Website will be accurate or reliable.
            </p>
            <p>
              You agree that from time to time we may remove the Website for
              indefinite periods of time or cease to operate the Website at any
              time, without notice to you.
            </p>
            <h2>
              <strong>PART THREE – General terms</strong>
            </h2>
            <h3>
              <strong>General conditions</strong>
            </h3>
            <ul>
              <li>
                The headings used in this agreement are included for convenience
                only and will not limit or otherwise affect the Terms.
              </li>
              <li>
                We reserve the right to refuse to provide our products or
                services to anyone for any reason at any time.
              </li>
              <li>You agree that you are over 18.</li>
              <li>
                The Terms are only available in English. No other languages
                apply to the Terms.
              </li>
              <li>
                Any breach of the Terms will result in an immediate termination
                of the Terms.
              </li>
            </ul>
            <h3>
              <strong>Your privacy and personal information</strong>
            </h3>
            <ul>
              <li>
                Your privacy and personal information are important to us. Any
                personal information that you provide to us will be dealt with
                in accordance with our{" "}
                <Link onClick={toTop} to="/privacy">
                  Privacy Policy
                </Link>
                , which explains what personal information we collect from you,
                how and why we collect, store, use and share such information,
                your rights in relation to your personal information and how to
                contact us and supervisory authorities if you have a query or
                complaint about the use of your personal information.
              </li>
              <li>
                Your payment information is always encrypted during transfer
                over networks.
              </li>
            </ul>
            <h3>
              <strong>
                Our responsibility for loss or damage suffered by you
              </strong>
            </h3>
            <p>
              By way of reminder, the Terms only apply to consumers. If you are
              a trade customer, please refer to our Terms and Conditions of Sale
              for our trade customers.
            </p>
            <p>
              We do not exclude or limit in any way our liability to you where
              it would be unlawful to do so. This includes liability for death
              or personal injury caused by our negligence or the negligence of
              our employees, agents or subcontractors and for fraud or
              fraudulent misrepresentation.
            </p>
            <p>
              You agree not to use our Website for any commercial or business
              purposes, and we have no liability to you for any loss of profit,
              loss of business, business interruption, or loss of business
              opportunity.
            </p>
            <h3>
              <strong>Entire agreement</strong>
            </h3>
            <p>
              The Terms constitute the entire agreement between the parties and
              supersedes and extinguishes all previous agreements, promises,
              assurances, warranties, representations and understandings between
              them, whether written or oral, relating to its subject matter.
            </p>
            <p>
              Each party agrees that it shall have no remedies in respect of any
              statement, representation, assurance or warranty (whether made
              innocently or negligently) that is not set out in the Terms. Each
              party agrees that it shall have no claim for innocent or negligent
              misrepresentation or negligent misstatement based on any statement
              in the Terms.
            </p>
            <h3>
              <strong>No waiver</strong>
            </h3>
            <p>
              No failure or delay by either you or us to exercise any right or
              remedy provided under the Terms or by law will constitute a waiver
              of that or any other right or remedy, or prevent or restrict the
              further exercise of that or any other right or remedy.
            </p>
            <h3>
              <strong>No partnership</strong>
            </h3>
            <p>
              Nothing in the Terms is intended to, or shall be deemed to,
              establish between you and us: (i) any partnership or joint
              venture; (ii) any agency relationship; or (iii) any other
              contractual commitment beyond those expressly identified in the
              Terms.
            </p>
            <h3>
              <strong>Severability</strong>
            </h3>
            <p>
              If any provision of the Terms is or becomes invalid, illegal or
              unenforceable, it shall be deemed deleted, but that shall not
              affect the validity and enforceability of the rest of the Terms.
            </p>
            <h3>
              <strong>Third party rights</strong>
            </h3>
            <p>
              No one other than you or us has any right to enforce the Terms or
              any part of the Terms.
            </p>
            <h3>
              <strong>Social media </strong>
            </h3>
            <p>
              Our social media policy is available{" "}
              <Link onClick={toTop} to="/">
                here
              </Link>
            </p>
            <h3>
              <strong>Disputes</strong>
            </h3>
            <p>
              We will try to resolve any disputes with you quickly and
              efficiently.
            </p>
            <p>
              If <span>you</span> are unhappy with the products, our service to
              you, or any other matter please contact us at [
              <Link onClick={toTop} to="mailto:draft@pedarcircle.club">
                draft@pedarcircle.club
              </Link>
              ] as soon as possible.
            </p>
            <p>
              If <span>it is not possible to resolve this</span> dispute with
              you directly, <span>we</span> will:
            </p>
            <ul>
              <li>
                let you know that we cannot settle the dispute with you; and
              </li>
              <li>
                give you certain information required about alternative dispute
                resolution.
              </li>
            </ul>
            <p>
              The laws of <span>England and Wales</span> will apply to the
              Terms. The court of England and Wales has exclusive jurisdiction
              in relation to the Terms.
            </p>
            <h2>
              <strong>PART Four –&nbsp;</strong>Terms and Conditions for Monthly
              “Win Your Hardware Order” Competition
            </h2>
            <h4>1 Competition Overview</h4>
            <p>
              Each month, <strong>Andcrafted Ltd T/A Pedarcircle</strong>{" "}
              (“Pedarcircle”) will randomly select one retail customer who has
              placed and paid for an order and left a review through our reviews
              platform (powered by Yotpo) during that month (the “Eligible
              Order”) to receive a refund of the cost of their hardware order
              (the “Prize”).
            </p>
            <h4>2 Eligibility</h4>
            <ul>
              <li>The competition is open to retail customers only.</li>
              <li>
                The competition is open to customers who leave a review directly
                with Pedarcircle via our reviews platform (powered by Yotpo).
              </li>
              <li>
                Trade customers, as well as individuals connected to or
                purchasing on behalf of a trade client, are excluded from
                entering this competition.
              </li>
              <li>The competition is limited to residents of the UK.</li>
              <li>
                Customers must be 18 years of age or older to participate.
              </li>
            </ul>
            <h4>3 How to Enter</h4>
            <ul>
              <li>
                No additional purchase or entry form is required to participate.
                By placing an Eligible Order on the Pedarcircle website, and by
                leaving a review via our reviews platform (powered by Yotpo),
                the customer is automatically entered for that month’s draw.
              </li>
              <li>
                Only one entry per Eligible Order will be included. Multiple
                orders will each constitute individual entries, provided all
                other terms are met.
              </li>
              <li>
                Does not include orders placed via third parties,
                intermediaries, retailers, or distributors.
              </li>
              <li>
                Any returned or canceled orders are disqualified from entry.
              </li>
            </ul>
            <h4>4 Draw and Prize</h4>
            <ul>
              <li>
                One winner will be randomly selected each month from all
                Eligible Orders placed within that month.
              </li>
              <li>
                The Prize consists solely of a refund of the cost of the
                hardware included in the Eligible Order.
              </li>
              <li>
                Pedarcircle will notify the winner via the contact information
                provided at the time of purchase within 10 days of the monthly
                draw.
              </li>
              <li>
                Refunds will be issued to the original payment method only,
                within 30 days of winner notification, pending order
                verification and acceptance.
              </li>
            </ul>
            <h4>5 Prize Conditions</h4>
            <ul>
              <li>
                The Prize is limited to the refund of the hardware cost; it
                excludes any other items or services included in the original
                order.
              </li>
              <li>
                The refund is provided solely as a return of the original
                purchase amount via the original payment method and holds no
                additional cash or equivalent value beyond that amount.
              </li>
              <li>The Prize is non-transferable and non-exchangeable.</li>
              <li>
                If the refunded order is returned to Pedarcircle for any reason,
                the customer is ineligible for an alternative prize or
                equivalent cash value.
              </li>
            </ul>
            <h4>6 General Terms</h4>
            <ul>
              <li>
                Pedarcircle reserves the right to verify the eligibility of all
                entrants and disqualify any participant if, in its reasonable
                opinion, there is a breach of these Terms and Conditions.
              </li>
              <li>
                Pedarcircle reserves the right to amend or withdraw this
                competition or these Terms and Conditions at any time without
                notice.
              </li>
              <li>
                By participating, entrants agree to abide by these Terms and
                Conditions and agree that any disputes shall be governed by
                English law.
              </li>
              <li>
                Pedarcircle’s decision on any matter regarding the competition
                shall be final.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </main>
  );
}

export default Terms;
